import { DadosAdicionaisComissoes } from "app/types/comissoes/DadosAdiconais";
import React from "react";
import { AbaDadosAdicionais } from "./AbaDadosAdiconais";

export type AbaDadosAdicionaisContainerProps = {
    listaDeDadosAdicionias: DadosAdicionaisComissoes[];
}

export const AbaDadosAdicionaisContainer = (props: AbaDadosAdicionaisContainerProps) => {
    return (
        <AbaDadosAdicionais 
            dadosAdicionais={props.listaDeDadosAdicionias} 
        />
    )
}